import Component from '@glimmer/component';

import eq from 'rise-ui/helpers/eq.js';

export default class OptionPlaceholderComponent extends Component {
  <template>
    <option
      class="c-option c-option--placeholder"
      value={{@value}}
      selected={{if (eq @selected @value) "true"}}
      disabled="true"
      hidden="true"
      ...attributes
    >{{yield}}</option>
  </template>
}
